import { cloneDeep } from 'lodash';
import { useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectControls } from '../../redux/controls';
import { selectItemRequest } from '../../redux/queryResults';
import { IItemRequest } from '../../shared';

import './SelectionsHeader.scss';
import { isAllCC, isAllChecked, reduceCC, reduceDL, reduceIT, reduceYr } from './SelectionsHeader.utils';

export const SelectionsHeader = (): JSX.Element => {
  const controls = useSelector(selectControls);
  const selectedItem = useSelector(selectItemRequest);

  const [item, setItem] = useState<IItemRequest | null>(null);

  useLayoutEffect(() => {
    setItem(cloneDeep(selectedItem));
  }, [selectedItem]);

  return (
    <div className={`nqt-selections mb-2 ${item ? 'd-flex' : 'd-none'}`}>
      <h3 className="nqt-selections--header">{controls?.SelectionsAre?.controlText}</h3>
      <div className="nqt-selections--sgy">
        <strong className="nqt-selections--strong">
          {controls?.Subject?.controlText}:&nbsp;
          {
            (item && item.SubjectGradeInfo?.length == 1) &&
          item.SubjectGradeInfo[0].label
          }
        </strong>&nbsp;/&nbsp;
        <strong className="nqt-selections--strong">
          {
            (item && item.SystemID === '3') ?
              controls?.Ages?.controlText :
              controls?.Grades?.controlText
          }:
        </strong>&nbsp;
        {
          item?.GradeStr.split(',').join(', ')
        }&nbsp;/&nbsp;
        <strong className="nqt-selections--strong">{controls?.SelHeaderYears?.controlText}:</strong>&nbsp;
        {
          item?.YearsInfo
            ?.sort((a, b) => b.year - a.year)
            .reduce(reduceYr, [])
        }
      </div>
      <div className="nqt-selections--selections-container">
        <strong className="nqt-selections--strong">{controls?.CCs?.controlText}</strong>&nbsp;
        {
          isAllCC(item?.ContentClassifications?.contentClassificationList) ?
            controls?.SelHeaderAll?.controlText :
            item?.ContentClassifications?.contentClassificationList?.reduce(reduceCC, [])
        }&nbsp;/&nbsp;
        <strong className="nqt-selections--strong">{controls?.HeadTypes?.controlText}:</strong>&nbsp;
        {
          isAllChecked(item?.ItemTypes) ?
            controls?.SelHeaderAll?.controlText :
            item?.ItemTypes?.reduce(reduceIT, [])
        }&nbsp;/&nbsp;
        <strong className="nqt-selections--strong">{controls?.DL?.controlText}:</strong>&nbsp;
        {
          isAllChecked(item?.DifficultyInfo) ?
            controls?.SelHeaderAll?.controlText :
            item?.DifficultyInfo?.reduce(reduceDL, [])
        }
        {
          item?.SubjectCode === 'MAT' &&
          <> &nbsp;/&nbsp;
            <strong className="nqt-selections--strong">{controls?.TTLCalculator?.controlText}</strong>&nbsp;
            {
              item?.CalculatorInfo === 'CALC' ? controls?.TTLCalculatorYes.controlText :
                item?.CalculatorInfo === 'NO_CALC' ?  controls?.TTLCalculatorNo.controlText :
                  controls?.SelHeaderAll?.controlText
            }
          </>
        }
        {
          item?.LimitToOnlineItems &&
          <>
            &nbsp;/&nbsp;
            <strong className="nqt-selections--strong">{controls?.HeadOnline?.controlText}</strong>
          </>
        }
        {
          item?.Keyword &&
          <>
            &nbsp;/&nbsp;
            <strong className="nqt-selections--strong">{controls?.HeadKeywords?.controlText}:</strong>&nbsp;
            {
              item?.Keyword
            }
          </>
        }

      </div>
    </div>
  );
};

export default SelectionsHeader;